"use strict";

var window = require("window"),
    $ = require("./jquery-plugins"),
    { trans } = require("./lib/translator"),
    gtxLoggedUser = require("./gtx-logged-user"),
    gtxConstants = require("./gtx-constants");

require("bootstrap-extend");

$(window.document).ready(function () {
    const checkIsLoggedPage =
        gtxLoggedUser("idAgente") &&
        window.location.href.indexOf("/login/a2f") === -1 &&
        window.location.href.indexOf("/check-status/tos") === -1;

    //include il menu
    if (checkIsLoggedPage) {
        if (gtxConstants("MENU_COUNTERS_ENABLED")) {
            if (gtxLoggedUser("hasMessaging")) {
                var GtxMessagingCounter = require("./gtx-messaging-counter");
                GtxMessagingCounter.initialize();
            }
            if (gtxLoggedUser("hasMatches")) {
                var GtxMatchesCounter = require("./gtx-matches-counter");
                GtxMatchesCounter.initialize();
            }
            var GtxFaviconTitleManager = require("./gtx-favicon-title-manager");
            GtxFaviconTitleManager.initialize();
            
            var GtxCountersManager = require("./gtx-menu-counters-worker-manager");

            GtxCountersManager.initialize();
        }
    }

    /* eslint-disable */
    Parsley.options.requiredMessage = trans("label.required_value");
    /* eslint-enable */
});
